import { render, staticRenderFns } from "./xinliceping.vue?vue&type=template&id=5bad98c6&"
import script from "./xinliceping.vue?vue&type=script&lang=ts&"
export * from "./xinliceping.vue?vue&type=script&lang=ts&"
import style0 from "./xinliceping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports